import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  mnemonic: Yup.string().required('Identificador é obrigatório').nullable(true),
  name: Yup.string().required('Nome é obrigatório').nullable(true),
  description: Yup.string().required('Descrição é obrigatória').nullable(true),
  avatar_url: Yup.string().required('URL do avatar é obrigatória').nullable(true),
  active: Yup.boolean().nullable(true),
});

export default validationSchema;
